













import { Component, Vue, Prop } from 'vue-property-decorator'
import tiny from '@/app/ui/components/Tiptap/index.vue'
import { OtherContentModule } from '@/app/store/modules/otherContent'
@Component({
  components: {
    tiny,
  },
})
export default class extends Vue {
  public created() {
    this.getData()
  }
  public getData() {
    const name = 'term'
    OtherContentModule.getOtherContentData({ name })
  }
  public get othersData() {
    return OtherContentModule.OtherContentData.data
  }
  public get isLoading() {
    return OtherContentModule.isLoading
  }
  public tinyOptions = {
    height: 200,
  }
  public saveData(item) {
    const dataToEdit = {
      name: 'term',
      content: item,
      fileUpload: null,
    }
    OtherContentModule.editOtherContentData(dataToEdit)
  }
  public cancel() {
    this.getData()
  }
}
